/**
 * Centralized logging utility
 * In production, these can be replaced with a proper logging service
 */

/**
 * Logs debug information (only in development)
 * @param {...any} args - Arguments to log
 */
export const logDebug = () => {
  // No console in production; use only in development if needed
};

/**
 * Logs error information
 * @param {...any} args - Arguments to log
 */
export const logError = (...args) => {
  // In production, this should be sent to an error tracking service
  // eslint-disable-next-line no-console
  console.error(...args);
};

/**
 * Logs warning information
 * @param {...any} args - Arguments to log
 */
export const logWarning = (...args) => {
  // eslint-disable-next-line no-console
  console.warn(...args);
};

